export default __webpack_public_path__ + "static/media/ctgb.7e3935b1.png";